module.exports = __webpack_public_path__ + "static/media/01-colorBlekluyImg.f1e10465.png";